/** SUNTRONIX ONE — reusable Click-to-Call button.
 * Logs an outgoing call via ONE Telephony and dials via tel: (or provider API).
 * Drop into Customer 360, Contact, Quote, Order, Ticket, Employee, Vendor. */
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Phone } from "lucide-react";

export const ClickToCall = ({
  number,
  label = "Call",
  contactName,
  customerName,
  customerAccountId,
  contactId,
  employeeId,
  relatedRecordType,
  relatedRecordId,
  relatedRecordLabel,
  size = "sm",
  variant = "solid",
  className = "",
  testId,
}) => {
  const [busy, setBusy] = useState(false);
  if (!number) return null;

  const call = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/telephony/click-to-call", {
        number,
        contact_name: contactName,
        customer_name: customerName,
        customer_account_id: customerAccountId,
        contact_id: contactId,
        employee_id: employeeId,
        related_record_type: relatedRecordType,
        related_record_id: relatedRecordId,
        related_record_label: relatedRecordLabel,
      });
      if (data.tel_uri) window.location.href = data.tel_uri;
      toast.success(`Call logged · ${data.provider}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not start call");
    } finally {
      setBusy(false);
    }
  };

  const base =
    variant === "solid"
      ? "bg-teal-800 text-white hover:bg-teal-900"
      : "border border-teal-700 text-teal-800 hover:bg-teal-50";
  const pad = size === "xs" ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-[11px]";

  return (
    <button
      type="button"
      disabled={busy}
      onClick={call}
      data-testid={testId || "click-to-call-btn"}
      className={`inline-flex items-center gap-1.5 rounded-md font-semibold transition-colors disabled:opacity-50 ${base} ${pad} ${className}`}
      title={`Call ${number}`}
    >
      <Phone className="h-3.5 w-3.5" />
      {label}
    </button>
  );
};

export default ClickToCall;
